import loadingGif from '../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from '../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Malzeme = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [malzemeAnaGrubuIdKriter, setMalzemeAnaGrubuIdKriter] = useState(0);
    const [malzemeGrubuIdKriter, setMalzemeGrubuIdKriter] = useState(0);
    const [cariIdUreticiKriter, setCariIdUreticiKriter] = useState(0);
    const [olcuBirimiIdKriter, setOlcuBirimiIdKriter] = useState(0);
    const [malzemeKriter, setMalzemeKriter] = useState("");
    const [parcaNoKriter, setParcaNoKriter] = useState("");
    const [malzemeKoduKriter, setMalzemeKoduKriter] = useState("");
    const [renkKoduKriter, setRenkKoduKriter] = useState("");
    const [olcuKriter, setOlcuKriter] = useState("");
    const [aciklamaKriter, setAciklamaKriter] = useState("");
    const [birlikteKullanilanMalzemeKriter, setBirlikteKullanilanMalzemeKriter] = useState("");
    const [kullanimOraniKriter, setKullanimOraniKriter] = useState("");
    const [esdegerKriter, setEsdegerKriter] = useState("");
    const [esdegerParcaNo1Kriter, setEsdegerParcaNo1Kriter] = useState("");
    const [esdegerParcaNo2Kriter, setEsdegerParcaNo2Kriter] = useState("");
    const [esdegerParcaNo3Kriter, setEsdegerParcaNo3Kriter] = useState("");
    const [gumrukTarifeNoKriter, setGumrukTarifeNoKriter] = useState("");
    const [yillikTaahhutKriter, setYillikTaahhutKriter] = useState();
    const [kovaIcerigiKriter, setKovaIcerigiKriter] = useState();
    const [paletIcerigiKriter, setPaletIcerigiKriter] = useState();

    const [malzemeAnaGrubuId, setMalzemeAnaGrubuId] = useState(0);
    const [malzemeGrubuId, setMalzemeGrubuId] = useState(0);
    const [cariIdUretici, setCariIdUretici] = useState(0);
    const [olcuBirimiId, setOlcuBirimiId] = useState(0);
    const [malzeme, setMalzeme] = useState("");
    const [parcaNo, setParcaNo] = useState("");
    const [malzemeKodu, setMalzemeKodu] = useState("");
    const [renkKodu, setRenkKodu] = useState("");
    const [olcu, setOlcu] = useState("");
    const [aciklama, setAciklama] = useState("");
    const [birlikteKullanilanMalzeme, setBirlikteKullanilanMalzeme] = useState("");
    const [kullanimOrani, setKullanimOrani] = useState("");
    const [esdeger, setEsdeger] = useState("");
    const [esdegerParcaNo1, setEsdegerParcaNo1] = useState("");
    const [esdegerParcaNo2, setEsdegerParcaNo2] = useState("");
    const [esdegerParcaNo3, setEsdegerParcaNo3] = useState("");
    const [gumrukTarifeNo, setGumrukTarifeNo] = useState("");
    const [yillikTaahhut, setYillikTaahhut] = useState(0);
    const [kovaIcerigi, setKovaIcerigi] = useState(0);
    const [paletIcerigi, setPaletIcerigi] = useState(0);
    const [malzemeFiyatAlisList, setMalzemeFiyatAlisList] = useState([]);
    const [malzemeFiyatSatisList, setMalzemeFiyatSatisList] = useState([]);

    const [currentId, setCurrentId] = useState(0);

    const [data, setData] = useState([]);
    const [dataMalzemeAnaGrubu, setDataMalzemeAnaGrubu] = useState([]);
    const [dataMalzemeGrubu, setDataMalzemeGrubu] = useState([]);
    const [dataCariUretici, setDataCariUretici] = useState([]);
    const [dataCariMusteri, setDataCariMusteri] = useState([]);
    const [dataOlcuBirimi, setDataOlcuBirimi] = useState([]);
    const [dataParaBirimi, setDataParaBirimi] = useState([]);

    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [sort, setSort] = useState("");

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const tableRef = useRef(null);

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [malzemeAnaGrubuIdKriter, malzemeGrubuIdKriter, cariIdUreticiKriter, olcuBirimiIdKriter, pageNo, pageSize, sort]);

    useEffect(() => {
        getAcilisData();
    }, []);

    const getAcilisData = async() => {
        if (tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Ürün Tanımları - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("ERP - Ürün Tanımları - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("ERP - Ürün Tanımları - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("ERP - Ürün Tanımları - Sil"));

            setDataMalzemeAnaGrubu((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/MalzemeAnaGrubu", { headers: AuthService.getHeaders() })).data.value);
            setDataOlcuBirimi((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/OlcuBirimi", { headers: AuthService.getHeaders() })).data.value);
            setDataParaBirimi((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/ParaBirimi", { headers: AuthService.getHeaders() })).data.value);
            setDataCariMusteri((await axios.get(settings.ApiUrl + "Lookup/GetCari/1", { headers: AuthService.getHeaders() })).data.value);
            setDataCariUretici((await axios.get(settings.ApiUrl + "Lookup/GetCari/2", { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

    const getData = async () => {
        try {
            setLoading(true);

            const kriter = JSON.stringify({
                "id": 0,
                "malzemeAnaGrubuId": malzemeAnaGrubuIdKriter,
                "malzemeGrubuId": malzemeGrubuIdKriter,
                "malzeme": malzemeKriter,
                "cariIdUretici": cariIdUreticiKriter,
                "parcaNo": parcaNoKriter,
                "malzemeKodu": malzemeKoduKriter,
                "renkKodu": renkKoduKriter,
                "olcu": olcuKriter,
                "aciklama": aciklamaKriter,
                "olcuBirimiId": olcuBirimiIdKriter,
                "yillikTaahhut": yillikTaahhutKriter ? yillikTaahhutKriter : 0,
                "kovaIcerigi": kovaIcerigiKriter ? kovaIcerigiKriter : 0,
                "paletIcerigi": paletIcerigiKriter ? paletIcerigiKriter : 0,
                "birlikteKullanilanMalzeme": birlikteKullanilanMalzemeKriter,
                "kullanimOrani": kullanimOraniKriter,
                "esdeger": esdegerKriter,
                "esdegerParcaNo1": esdegerParcaNo1Kriter,
                "esdegerParcaNo2": esdegerParcaNo2Kriter,
                "esdegerParcaNo3": esdegerParcaNo3Kriter,
                "gumrukTarifeNo": gumrukTarifeNoKriter,
                "sort": sort,
                "pageNo": pageNo,
                "pageSize": pageSize
            });

            const res = await axios.post(settings.ApiUrl + 'Malzeme/GetMalzemeList/', kriter, { headers: AuthService.getHeaders() });

            if (res) {
                setRowCount(res.data.rowCount);
                setLastPage(Math.ceil(res.data.rowCount / pageSize));
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleSortClick = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        let temp = sort;

        const name = e.target.name;

        if (temp.startsWith(name)) {
            if (temp === name) {
                temp = name + " DESC";
            } else {
                temp = "";
            }            
        } else {
            temp = name;
        }

        setPageNo(1);
        setSort(temp);
    };

    const handlePageSize = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const Suz = async () => {
        if (tokenYenile() === false) {
            return;
        }

        setPageNo(1);

        await getData();
    }

    const handleMalzemeAnaGrubuIdKriterChange = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPageNo(1);

        setMalzemeAnaGrubuIdKriter(e.target.value);
        setMalzemeGrubuIdKriter(0);

        setDataMalzemeGrubu((await axios.get(settings.ApiUrl + "Lookup/GetMalzemeGrubu/" + e.target.value, { headers: AuthService.getHeaders() })).data.value);
    }

    const handleMalzemeAnaGrubuIdChange = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPageNo(1);

        setMalzemeAnaGrubuId(e.target.value);
        setMalzemeGrubuId(0);

        setDataMalzemeGrubu((await axios.get(settings.ApiUrl + "Lookup/GetMalzemeGrubu/" + e.target.value, { headers: AuthService.getHeaders() })).data.value);
    }

    const handleTarih = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].tarih = value;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const handleParaBirimi = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].paraBirimiId = value;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const handleKovaIcerigi = async (value) => {
        setKovaIcerigi(value);

        const tempAlis =[...malzemeFiyatAlisList];
        const tempSatis =[...malzemeFiyatAlisList];

        tempAlis.forEach(element => {
            let kovaFiyati = element.fiyat * (100 - element.iskontoOrani) / 100 * Number(value);
            let paletFiyati =  kovaFiyati * Number(value);

            element.kovaFiyati = Math.round(kovaFiyati * 10000) / 10000;
            element.paletFiyati = Math.round(paletFiyati * 10000) / 10000;
        });

        tempSatis.forEach(element => {
            let kovaFiyati = element.fiyat * (100 - element.iskontoOrani) / 100 * Number(value);
            let paletFiyati =  kovaFiyati * Number(value);

            element.kovaFiyati = Math.round(kovaFiyati * 10000) / 10000;
            element.paletFiyati = Math.round(paletFiyati * 10000) / 10000;
        });

        setMalzemeFiyatAlisList(tempAlis);
        setMalzemeFiyatSatisList(tempSatis);
    }

    const handlePaletIcerigi = async (value) => {
        setPaletIcerigi(value);

        const tempAlis = [...malzemeFiyatAlisList];
        const tempSatis = [...malzemeFiyatSatisList];

        tempAlis.forEach(element => {
            let paletFiyati = element.fiyat * (100 - element.iskontoOrani) / 100 * kovaIcerigi * Number(value);

            element.paletFiyati = Math.round(paletFiyati * 10000) / 10000;
        });

        tempSatis.forEach(element => {
            let paletFiyati = element.fiyat * (100 - element.iskontoOrani) / 100 * kovaIcerigi * Number(value);

            element.paletFiyati = Math.round(paletFiyati * 10000) / 10000;
        });

        setMalzemeFiyatAlisList(tempAlis);
        setMalzemeFiyatSatisList(tempSatis);
    }

    const handleFiyat = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].fiyat = Number(value);

        let kdv = Number(value) / 100 * Number(temp[index].kdvOrani);
        let kdvliFiyat = Number(value) + kdv;
        let iskonto = kdvliFiyat / 100 * Number(temp[index].iskontoOrani);
        let iskontoluFiyat = kdvliFiyat - iskonto;
        let kovaFiyati = iskontoluFiyat * kovaIcerigi;
        let paletFiyati = kovaFiyati * paletIcerigi;

        temp[index].kdv = Math.round(kdv * 10000) / 10000;
        temp[index].kdvliFiyat = Math.round(kdvliFiyat * 10000) / 10000;
        temp[index].iskonto = Math.round(iskonto * 10000) / 10000;
        temp[index].iskontoluFiyat = Math.round(iskontoluFiyat * 10000) / 10000;
        temp[index].kovaFiyati = Math.round(kovaFiyati * 10000) / 10000;
        temp[index].paletFiyati = Math.round(paletFiyati * 10000) / 10000;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const handleKdvOrani = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].kdvOrani = Number(value);

        let kdv = Number(temp[index].fiyat) / 100 * Number(value);
        let kdvliFiyat = Number(temp[index].fiyat) + kdv;
        let iskonto = kdvliFiyat / 100 * Number(temp[index].iskontoOrani);
        let iskontoluFiyat = kdvliFiyat - iskonto;
        let kovaFiyati = iskontoluFiyat * kovaIcerigi;
        let paletFiyati = kovaFiyati * paletIcerigi;

        temp[index].kdv = Math.round(kdv * 10000) / 10000;
        temp[index].kdvliFiyat = Math.round(kdvliFiyat * 10000) / 10000;
        temp[index].iskonto = Math.round(iskonto * 10000) / 10000;
        temp[index].iskontoluFiyat = Math.round(iskontoluFiyat * 10000) / 10000;
        temp[index].kovaFiyati = Math.round(kovaFiyati * 10000) / 10000;
        temp[index].paletFiyati = Math.round(paletFiyati * 10000) / 10000;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const handleIskontoOrani = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].iskontoOrani = Number(value);

        let iskonto = Number(temp[index].kdvliFiyat) / 100 * Number(value);
        let iskontoluFiyat = Number(temp[index].kdvliFiyat) - iskonto;
        let kovaFiyati = iskontoluFiyat * kovaIcerigi;
        let paletFiyati = kovaFiyati * paletIcerigi;

        temp[index].iskonto = Math.round(iskonto * 10000) / 10000;
        temp[index].iskontoluFiyat = Math.round(iskontoluFiyat * 10000) / 10000;
        temp[index].kovaFiyati = Math.round(kovaFiyati * 10000) / 10000;
        temp[index].paletFiyati = Math.round(paletFiyati * 10000) / 10000;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const handleCariMusteri = async (value, index, alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        temp[index].cariIdMusteri = value;

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const EkleMalzemeFiyat = async (alisSatis) => {
        const temp = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        if (alisSatis === "alis") {
            const bosKayit = {
                id: 0,
                malzemeId: 0,
                tarih: null,
                fiyat: 0,
                paraBirimiId: 0,
                paraBirimi: "",
                kdvOrani: 0,
                kdv: 0,
                kdvliFiyat: 0,
                iskontoOrani: 0,
                iskonto: 0,
                iskontoluFiyat: 0,
                kovaFiyati: 0,
                paletFiyati: 0
            }

            temp.push(bosKayit);

            setMalzemeFiyatAlisList(temp);
        } else {
            const bosKayit = {
                id: 0,
                malzemeId: 0,
                tarih: null,
                fiyat: 0,
                paraBirimiId: 0,
                paraBirimi: "",
                cariIdMusteri: 0,
                cariMusteri: "",
                kdvOrani: 0,
                kdv: 0,
                kdvliFiyat: 0,
                iskontoOrani: 0,
                iskonto: 0,
                iskontoluFiyat: 0,
                kovaFiyati: 0,
                paletFiyati: 0
            }

            temp.push(bosKayit);

            setMalzemeFiyatSatisList(temp);
        }
    }

    const SilMalzemeFiyat = async (index, alisSatis) => {
        const temp = [];

        const tempIlk = alisSatis === "alis" ? [...malzemeFiyatAlisList] : [...malzemeFiyatSatisList];

        let i = 0;

        tempIlk.forEach(element => {
            if (i !== index) {
                temp.push(element);
            }
            i++;
        });

        if (alisSatis === "alis") {
            setMalzemeFiyatAlisList(temp);
        } else {
            setMalzemeFiyatSatisList(temp);
        }
    }

    const Ekle = async () => {
        if (tokenYenile() === false) {
            return;
        }

        setDataMalzemeGrubu((await axios.get(settings.ApiUrl + "Lookup/GetMalzemeGrubu/0", { headers: AuthService.getHeaders() })).data.value);

        setCurrentId(0);

        setMalzemeAnaGrubuId(0);
        setMalzemeGrubuId(0);
        setCariIdUretici(0);
        setOlcuBirimiId(0);
        setMalzeme("");
        setParcaNo("");
        setMalzemeKodu("");
        setRenkKodu("");
        setOlcu("");
        setAciklama("");
        setBirlikteKullanilanMalzeme("");
        setKullanimOrani("");
        setEsdeger("");
        setEsdegerParcaNo1("");
        setEsdegerParcaNo2("");
        setEsdegerParcaNo3("");
        setGumrukTarifeNo("");
        setYillikTaahhut(0);
        setKovaIcerigi(0);
        setPaletIcerigi(0);
        setMalzemeFiyatAlisList([]);
        setMalzemeFiyatSatisList([]);

        handleShow();
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Malzeme/GetMalzeme/' + id, { headers: AuthService.getHeaders() });

            if (res) {
                setDataMalzemeGrubu((await axios.get(settings.ApiUrl + "Lookup/GetMalzemeGrubu/" + res.data.value.malzemeAnaGrubuId, { headers: AuthService.getHeaders() })).data.value);

                setCurrentId(id);
                setMalzemeAnaGrubuId(res.data.value.malzemeAnaGrubuId);
                setMalzemeGrubuId(res.data.value.malzemeGrubuId);
                setCariIdUretici(res.data.value.cariIdUretici);
                setOlcuBirimiId(res.data.value.olcuBirimiId);
                setMalzeme(res.data.value.malzeme);
                setParcaNo(res.data.value.parcaNo);
                setMalzemeKodu(res.data.value.malzemeKodu);
                setRenkKodu(res.data.value.renkKodu);
                setOlcu(res.data.value.olcu);
                setAciklama(res.data.value.aciklama);
                setBirlikteKullanilanMalzeme(res.data.value.birlikteKullanilanMalzeme);
                setKullanimOrani(res.data.value.kullanimOrani);
                setEsdeger(res.data.value.esdeger);
                setEsdegerParcaNo1(res.data.value.esdegerParcaNo1);
                setEsdegerParcaNo2(res.data.value.esdegerParcaNo2);
                setEsdegerParcaNo3(res.data.value.esdegerParcaNo3);
                setGumrukTarifeNo(res.data.value.gumrukTarifeNo);
                setYillikTaahhut(res.data.value.yillikTaahhut);
                setKovaIcerigi(res.data.value.kovaIcerigi);
                setPaletIcerigi(res.data.value.paletIcerigi);
                setMalzemeFiyatAlisList(res.data.value.malzemeFiyatAlisList);
                setMalzemeFiyatSatisList(res.data.value.malzemeFiyatSatisList);

                handleShow();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Malzeme/GetMalzeme/' + id, { headers: AuthService.getHeaders() });
        
                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Malzeme/DeleteMalzeme/', [resultGet.data.value], { headers: AuthService.getHeaders() });
                        
                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (tokenYenile() === false) {
            return;
        }

        // Üstteki bilgilerde zorunlu alan konttolü

        if (Number(malzemeAnaGrubuId) === 0 || Number(malzemeGrubuId) === 0 || Number(cariIdUretici) === 0 || malzeme === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
            return;
        }

        // Alış fiyatlarında zorunlu alan konttolü

        let hataliSatirAlis = 0;

        for (let index = 0; index < malzemeFiyatAlisList.length; index++) {
            const element = malzemeFiyatAlisList[index];
            if (!element.tarih || element.paraBirimiId === 0 || element.fiyat === 0) {
                hataliSatirAlis = index + 1;
                break;
            }
        }

        if (hataliSatirAlis !== 0) {
            Swal.fire({ title: "Hata", text: "Alış fiyatlarının " + hataliSatirAlis + ". satırında eksik bilgi. Lütfen zorunlu alanları doldurunuz veya kaydetmek istemediğiniz satırı siliniz.", icon: "error" });
            return;    
        }

        // Satış fiyatlarında zorunlu alan konttolü

        let hataliSatirSatis = 0;

        for (let index = 0; index < malzemeFiyatSatisList.length; index++) {
            const element = malzemeFiyatSatisList[index];
            if (!element.tarih || element.paraBirimiId === 0 || element.cariIdMusteri === 0 || element.fiyat === 0) {
                hataliSatirSatis = index + 1;
                break;
            }
        }

        if (hataliSatirSatis !== 0) {
            Swal.fire({ title: "Hata", text: "Satış fiyatlarının " + hataliSatirSatis + ". satırında eksik bilgi. Lütfen zorunlu alanları doldurunuz veya kaydetmek istemediğiniz satırı siliniz.", icon: "error" });
            return;    
        }

        // Göm

        try {
            const data = JSON.stringify({
                "id": currentId,
                "malzemeAnaGrubuId": malzemeAnaGrubuId,
                "malzemeGrubuId": malzemeGrubuId,
                "malzeme": malzeme,
                "cariIdUretici": cariIdUretici,
                "parcaNo": parcaNo,
                "malzemeKodu": malzemeKodu,
                "renkKodu": renkKodu,
                "olcu": olcu,
                "aciklama": aciklama,
                "birlikteKullanilanMalzeme": birlikteKullanilanMalzeme,
                "olcuBirimiId": olcuBirimiId,
                "yillikTaahhut": yillikTaahhut,
                "kovaIcerigi": kovaIcerigi,
                "paletIcerigi": paletIcerigi,
                "kullanimOrani": kullanimOrani,
                "esdeger": esdeger,
                "esdegerParcaNo1": esdegerParcaNo1,
                "esdegerParcaNo2": esdegerParcaNo2,
                "esdegerParcaNo3": esdegerParcaNo3,
                "gumrukTarifeNo": gumrukTarifeNo,
                "malzemeFiyatAlisList": malzemeFiyatAlisList,
                "malzemeFiyatSatisList": malzemeFiyatSatisList
            });

            console.log(data);

            const result = await axios.post(settings.ApiUrl + 'Malzeme/InsertOrUpdateMalzeme/', data, { headers: AuthService.getHeaders() });

            if (result) {
                if (result.data.success) {
                    handleClose();
                    getData();
                    toast.success("Kaydedildi");
                } else {
                    toast.error("Hata oluştu: " + result.data.message);
                }
            }
        } catch (error) {
            toast.error("Hata oluştu:" + error);
        }
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'StokKartiListesi',
        sheet: 'StokKartiListesi'
    })

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            <PageTitle></PageTitle>
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                            <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th colSpan="11" style={{textAlign:"center"}}>GENEL BİLGİLER</th>
                                                <th colSpan="9" style={{textAlign:"center"}}>BOYA GRUBU BİLGİLERİ</th>
                                            </tr>
                                            <tr>
                                                <th style={{textAlign:"center", width:"8%"}}><button name="MalzemeAnaGrubu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ana Ürün</button></th>
                                                <th style={{textAlign:"center", width:"8%"}}><button name="CariUretici" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Üretici</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="ParcaNo" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Parça No</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="MalzemeGrubu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ürün Grubu</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="MalzemeKodu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ürün Kodu</button></th>
                                                <th style={{textAlign:"center", width:"8%"}}><button name="Malzeme" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ürün Adı</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="Olcu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>ölçüsü</button></th>
                                                <th style={{textAlign:"center", width:"8%"}}><button name="Aciklama" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Açıklama</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="OlcuBirimi" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ölçü Birimi</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="YillikTaahhut" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Yıllık Taahhüt</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="GumrukTarifeNo" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>GÜmrük Tarife No</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="RenkKodu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Renk Kodu</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="KovaIcerigi" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>1 Kova İçeriği (Lt)</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="PaletIcerigi" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Palet İçeriği (Ad)</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="BirlikteKullanilanMalzeme" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Birlikte Kullanılan Malzeme</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}><button name="KullanimOrani" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Kullanım Oranı</button></th>
                                                <th style={{textAlign:"center", width:"3%"}}><button name="Esdeger" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Eşdeğeri</button></th>
                                                <th style={{textAlign:"center", width:"3%"}}><button name="EsdegerParcaNo1" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Eşdeğer Parça No 1</button></th>
                                                <th style={{textAlign:"center", width:"3%"}}><button name="EsdegerParcaNo2" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Eşdeğer Parça No 2</button></th>
                                                <th style={{textAlign:"center", width:"3%"}}><button name="EsdegerParcaNo3" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Eşdeğer Parça No 3</button></th>
                                                <th style={{textAlign:"center", width:"4%"}}>
                                                    { yetkiEkle ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : '' }
                                                    <button className="btn btn-sm btn-icon text-success" onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style={{ textAlign: "center" }}>
                                                    <select className="form-select form-select-sm" value={malzemeAnaGrubuIdKriter} onChange={async (e) => handleMalzemeAnaGrubuIdKriterChange(e)}>
                                                        <option value={0}></option>
                                                        {
                                                            dataMalzemeAnaGrubu && dataMalzemeAnaGrubu.length > 0 ?
                                                            dataMalzemeAnaGrubu.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                )
                                                            })
                                                            :
                                                            null
                                                        }
                                                    </select>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <select className="form-select form-select-sm" value={cariIdUreticiKriter} onChange={(e) => setCariIdUreticiKriter(e.target.value)}>
                                                        <option value={0}></option>
                                                        {
                                                            dataCariUretici && dataCariUretici.length > 0 ?
                                                            dataCariUretici.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                )
                                                            })
                                                            :
                                                            null
                                                        }
                                                    </select>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={parcaNoKriter} onChange={(e) => setParcaNoKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <select aria-describedby="lblMalzemeGrubu" className="form-select form-select-sm" value={malzemeGrubuIdKriter} onChange={(e) => setMalzemeGrubuIdKriter(e.target.value)}>
                                                        <option value={0}></option>
                                                        {
                                                            dataMalzemeGrubu && dataMalzemeGrubu.length > 0 ?
                                                            dataMalzemeGrubu.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                )
                                                            })
                                                            :
                                                            null
                                                        }
                                                    </select>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={malzemeKoduKriter} onChange={(e) => setMalzemeKoduKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={malzemeKriter} onChange={(e) => setMalzemeKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={olcuKriter} onChange={(e) => setOlcuKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={aciklamaKriter} onChange={(e) => setAciklamaKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <select className="form-select form-select-sm" value={olcuBirimiIdKriter} onChange={(e) => setOlcuBirimiIdKriter(e.target.value)}>
                                                        <option value={0}></option>
                                                        {
                                                            dataOlcuBirimi && dataOlcuBirimi.length > 0 ?
                                                            dataOlcuBirimi.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                )
                                                            })
                                                            :
                                                            null
                                                        }
                                                    </select>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"center"}} value={yillikTaahhutKriter} onChange={(e) => setYillikTaahhutKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={gumrukTarifeNoKriter} onChange={(e) => setGumrukTarifeNoKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={renkKoduKriter} onChange={(e) => setRenkKoduKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"center"}} value={kovaIcerigiKriter} onChange={(e) => setKovaIcerigiKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"center"}} value={paletIcerigiKriter} onChange={(e) => setPaletIcerigiKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={birlikteKullanilanMalzemeKriter} onChange={(e) => setBirlikteKullanilanMalzemeKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={kullanimOraniKriter} onChange={(e) => setKullanimOraniKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={esdegerKriter} onChange={(e) => setEsdegerKriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={esdegerParcaNo1Kriter} onChange={(e) => setEsdegerParcaNo1Kriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={esdegerParcaNo2Kriter} onChange={(e) => setEsdegerParcaNo2Kriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <input type="text" className="form-control form-control-sm" value={esdegerParcaNo3Kriter} onChange={(e) => setEsdegerParcaNo3Kriter(e.target.value)}></input>
                                                </th>
                                                <th style={{ textAlign: "center" }}>
                                                    <button className="btn btn-sm btn-icon text-info" onClick={() => Suz()}><i className="bi bi-search"></i></button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td align="center"><span className={item.malzemeAnaGrubuBadge}>{item.malzemeAnaGrubu}</span></td>
                                                                <td align="center">{item.cariUretici}</td>
                                                                <td align="center">{item.parcaNo}</td>
                                                                <td align="center">{item.malzemeGrubu}</td>
                                                                <td align="center">{item.malzemeKodu}</td>
                                                                <td align="center">{item.malzeme}</td>
                                                                <td align="center">{item.olcu}</td>
                                                                <td align="center">{item.aciklama}</td>
                                                                <td align="center">{item.olcuBirimi}</td>
                                                                <td align="center">{item.yillikTaahhut}</td>
                                                                <td align="center">{item.gumrukTarifeNo}</td>
                                                                <td align="center">{item.renkKodu}</td>
                                                                <td align="center">{item.kovaIcerigi}</td>
                                                                <td align="center">{item.paletIcerigi}</td>
                                                                <td align="center">{item.birlikteKullanilanMalzeme}</td>
                                                                <td align="center">{item.kullanimOrani}</td>
                                                                <td align="center">{item.esdeger}</td>
                                                                <td align="center">{item.esdegerParcaNo1}</td>
                                                                <td align="center">{item.esdegerParcaNo2}</td>
                                                                <td align="center">{item.esdegerParcaNo3}</td>
                                                                <td align="center">
                                                                    <div className="btn-group">
                                                                        { yetkiDegistir ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                        { yetkiSil ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="22" style={{height:"48px"}}>
                                                            Kayıt yok
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                    <div className="col-md-4" style={{ display: "ruby" }}>
                                        <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                        <div style={{ display: "flex", width: "224px" }}>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                            <div className="input-group">
                                                <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                            </div>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                        <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                            <option value="5">5 kayıt göster</option>
                                            <option value="10">10 kayıt göster</option>
                                            <option value="25">25 kayıt göster</option>
                                            <option value="50">50 kayıt göster</option>
                                            <option value="100">100 kayıt göster</option>
                                            <option value="250">250 kayıt göster</option>
                                            <option value="500">500 kayıt göster</option>
                                            <option value="1000">1000 kayıt göster</option>
                                            <option value="5000">5000 kayıt göster</option>
                                            <option value="10000">10000 kayıt göster</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} fullscreen={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Stok Kartı Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className={Number(malzemeAnaGrubuId) === 1 ? "col-md-6" : "col-md-12"}>
                            <div className="card mb-3">
                                <div className="card-body">
                                    <h5 className="card-title">Genel Bilgiler</h5>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblMalzemeAnaGrubu" style={{width:"152px"}}>Ana Ürün<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                                        <select aria-describedby="lblMalzemeAnaGrubu" className="form-select form-select-sm" value={malzemeAnaGrubuId} onChange={async (e) => handleMalzemeAnaGrubuIdChange(e)}>
                                                            <option value={0}></option>
                                                            {
                                                                dataMalzemeAnaGrubu && dataMalzemeAnaGrubu.length > 0 ?
                                                                dataMalzemeAnaGrubu.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblMalzemeGrubu" style={{width:"152px"}}>Ürün Grubu<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                                        <select aria-describedby="lblMalzemeGrubu" className="form-select form-select-sm" value={malzemeGrubuId} onChange={(e) => setMalzemeGrubuId(e.target.value)}>
                                                            <option value={0}></option>
                                                            {
                                                                dataMalzemeGrubu && dataMalzemeGrubu.length > 0 ?
                                                                dataMalzemeGrubu.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblCariUretici" style={{width:"152px"}}>Üretici<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                                        <select aria-describedby="lblCariUretici" className="form-select form-select-sm" value={cariIdUretici} onChange={(e) => setCariIdUretici(e.target.value)}>
                                                            <option value={0}></option>
                                                            {
                                                                dataCariUretici && dataCariUretici.length > 0 ?
                                                                dataCariUretici.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblMalzeme" style={{width:"152px"}}>Ürün Adı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                                        <input aria-describedby="lblMalzeme" type="text" className="form-control form-control-sm" value={malzeme} onChange={(e) => setMalzeme(e.target.value)}></input>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblParcaNo" style={{width:"152px"}}>Parça No</label>
                                                        <input aria-describedby="lblParcaNo" type="text" className="form-control form-control-sm" value={parcaNo} onChange={(e) => setParcaNo(e.target.value)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblMalzemeKodu" style={{width:"152px"}}>Ürün Kodu</label>
                                                        <input aria-describedby="lblMalzemeKodu" type="text" className="form-control form-control-sm" value={malzemeKodu} onChange={(e) => setMalzemeKodu(e.target.value)}></input>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblOlcuBirimi" style={{width:"152px"}}>{ Number(malzemeAnaGrubuId) === 1 ? "Ölçü Birimi" : "Ölçü Birimi / Ölçüsü"}</label>
                                                        <select aria-describedby="lblOlcuBirimi" className="form-select form-select-sm" value={olcuBirimiId} onChange={(e) => setOlcuBirimiId(e.target.value)}>
                                                            <option value={0}></option>
                                                            {
                                                                dataOlcuBirimi && dataOlcuBirimi.length > 0 ?
                                                                dataOlcuBirimi.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                        {
                                                            Number(malzemeAnaGrubuId) === 1 ?
                                                                ""
                                                                :
                                                                <input aria-describedby="lblOlcu" type="text" className="form-control form-control-sm" value={olcu} onChange={(e) => setOlcu(e.target.value)}></input>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblYillikTaahhut" style={{width:"152px"}}>Yıllık Taahhüt</label>
                                                        <input aria-describedby="lblYillikTaahhut" type="number" className="form-control form-control-sm spinButtonWithoutArrows" value={yillikTaahhut} onChange={(e) => setYillikTaahhut(e.target.value)}></input>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblGumrukTarifeNo" style={{width:"152px"}}>Gümrük Tar. No</label>
                                                        <input aria-describedby="lblGumrukTarifeNo" type="text" className="form-control form-control-sm" value={gumrukTarifeNo} onChange={(e) => setGumrukTarifeNo(e.target.value)}></input>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-group input-group-sm">
                                                        <label className="input-group-text" id="lblAciklama" style={{width:"152px"}}>Ürün Açıklaması</label>
                                                        <input aria-describedby="lblAciklama" type="text" className="form-control form-control-sm" value={aciklama} onChange={(e) => setAciklama(e.target.value)}></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            Number(malzemeAnaGrubuId) === 1 ?
                                <div className="col-md-6">
                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <h5 className="card-title">Boya Grubu Bilgileri</h5>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblRenkKodu" style={{width:"152px"}}>Renk Kodu</label>
                                                                <input aria-describedby="lblRenkKodu" type="text" className="form-control form-control-sm" value={renkKodu} onChange={(e) => setRenkKodu(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblKovaIcerigi" style={{width:"152px"}}>Kova İçeriği</label>
                                                                <input aria-describedby="lblKovaIcerigi" type="number" className="form-control form-control-sm spinButtonWithoutArrows" value={kovaIcerigi} onChange={(e) => handleKovaIcerigi(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblPaletIcerigi" style={{width:"152px"}}>Palet İçeriği</label>
                                                                <input aria-describedby="lblPaletIcerigi" type="number" className="form-control form-control-sm spinButtonWithoutArrows" value={paletIcerigi} onChange={(e) => handlePaletIcerigi(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblBirlikteKullanilanMalzeme" style={{width:"152px"}}>Birlikte Kul. Mlz.</label>
                                                                <input aria-describedby="lblBirlikteKullanilanMalzeme" type="text" className="form-control form-control-sm" value={birlikteKullanilanMalzeme} onChange={(e) => setBirlikteKullanilanMalzeme(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblKullanimOrani" style={{width:"152px"}}>Kullanım Oranı</label>
                                                                <input aria-describedby="lblKullanimOrani" type="text" className="form-control form-control-sm" value={kullanimOrani} onChange={(e) => setKullanimOrani(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblEsdeger" style={{width:"152px"}}>Eşdeğeri</label>
                                                                <input aria-describedby="lblEsdeger" type="text" className="form-control form-control-sm" value={esdeger} onChange={(e) => setEsdeger(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblEsdegerParcaNo1" style={{width:"152px"}}>Eşdeğer Prç. No 1</label>
                                                                <input aria-describedby="lblEsdegerParcaNo1" type="text" className="form-control form-control-sm" value={esdegerParcaNo1} onChange={(e) => setEsdegerParcaNo1(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblEsdegerParcaNo2" style={{width:"152px"}}>Eşdeğer  Prç. No 2</label>
                                                                <input aria-describedby="lblEsdegerParcaNo2" type="text" className="form-control form-control-sm" value={esdegerParcaNo2} onChange={(e) => setEsdegerParcaNo2(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="input-group input-group-sm">
                                                                <label className="input-group-text" id="lblEsdegerParcaNo3" style={{width:"152px"}}>Eşdeğer Prç. No 3</label>
                                                                <input aria-describedby="lblEsdegerParcaNo3" type="text" className="form-control form-control-sm" value={esdegerParcaNo3} onChange={(e) => setEsdegerParcaNo3(e.target.value)}></input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    :
                                    ""
                        }
                        <div className="col-md-12 mb-3">
                            <div className="table-responsive card mb-0" style={{maxHeight:"200px", overflowY:"auto"}}>
                                <table className="table table-bordered table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th colSpan={Number(malzemeAnaGrubuId) === 1 ? 13 : 11} style={{textAlign:"center"}}>
                                                ALIŞ FİYATLARI
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style={{textAlign:"center", width:"8%"}}>Geçerlilik Tarihi</th>
                                            <th style={{textAlign:"center", width:"8%"}}></th>
                                            <th style={{textAlign:"center", width:"8%"}}>Para Birimi</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Fiyat</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdv %</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdv Tutarı</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdvli Fiyat</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İsk. %</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İskonto Tutarı</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İskontolu Fiyat</th>
                                            { Number(malzemeAnaGrubuId) === 1 ? <th style={{textAlign:"center", width:"8%"}}>Kova Fiyatı</th> : "" }
                                            { Number(malzemeAnaGrubuId) === 1 ? <th style={{textAlign:"center", width:"8%"}}>Palet Fiyatı</th> : "" }
                                            <th style={{textAlign:"center", width:"8%"}}>
                                                <button className="btn btn-sm btn-icon text-success" onClick={() => EkleMalzemeFiyat("alis")}><i className="bi bi-plus-circle"></i></button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            malzemeFiyatAlisList && malzemeFiyatAlisList.length > 0 ?
                                                malzemeFiyatAlisList.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td align="center">
                                                                <div className="form-control form-control-sm">
                                                                    <DatePicker className="form-control form-control-sm datePickerInFormControlBox" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" selected={item.tarih} onChange={(value) => { handleTarih(value, index, "alis"); }} />
                                                                </div>
                                                            </td>
                                                            <td></td>
                                                            <td align="center">
                                                                <select className="form-select form-select-sm" value={item.paraBirimiId} onChange={(e) => handleParaBirimi(e.target.value, index, "alis")}>
                                                                    <option value={0}></option>
                                                                    {
                                                                        dataParaBirimi && dataParaBirimi.length > 0 ?
                                                                        dataParaBirimi.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.id}>{item.ad}</option>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.fiyat} onChange={(e) => handleFiyat(e.target.value, index, "alis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdvOrani} onChange={(e) => handleKdvOrani(e.target.value, index, "alis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdv} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdvliFiyat} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskontoOrani} onChange={(e) => handleIskontoOrani(e.target.value, index, "alis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskonto} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskontoluFiyat} disabled></input>
                                                            </td>
                                                            {
                                                                Number(malzemeAnaGrubuId) === 1 ? 
                                                                    <td align="center">
                                                                        <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kovaFiyati} disabled></input>
                                                                    </td>
                                                                    :
                                                                    ""
                                                            }
                                                            {
                                                                Number(malzemeAnaGrubuId) === 1 ? 
                                                                    <td align="center">
                                                                        <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.paletFiyati} disabled></input>
                                                                    </td>
                                                                    :
                                                                    ""
                                                            }
                                                            <td align="center">
                                                                <button className="btn btn-sm btn-icon text-danger" onClick={() => SilMalzemeFiyat(index, "alis")}><i className="bi bi-trash3"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td align="center" colSpan={Number(malzemeAnaGrubuId) === 1 ? 13 : 11} style={{height:"48px"}}>
                                                        Kayıt yok
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive card mb-0" style={{maxHeight:"200px", overflowY:"auto"}}>
                                <table className="table table-bordered table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th colSpan={Number(malzemeAnaGrubuId) === 1 ? 13 : 11} style={{textAlign:"center"}}>
                                                SATIŞ FİYATLARI
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style={{textAlign:"center", width:"8%"}}>Geçerlilik Tarihi</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Müşteri</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Para Birimi</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Fiyat</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdv %</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdv Tutarı</th>
                                            <th style={{textAlign:"center", width:"8%"}}>Kdvli Fiyat</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İsk. %</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İskonto Tutarı</th>
                                            <th style={{textAlign:"center", width:"8%"}}>İskontolu Fiyat</th>
                                            { Number(malzemeAnaGrubuId) === 1 ? <th style={{textAlign:"center", width:"8%"}}>Kova Fiyatı</th> : "" }
                                            { Number(malzemeAnaGrubuId) === 1 ? <th style={{textAlign:"center", width:"8%"}}>Palet Fiyatı</th> : "" }
                                            <th style={{textAlign:"center", width:"8%"}}>
                                                <button className="btn btn-sm btn-icon text-success" onClick={() => EkleMalzemeFiyat("satis")}><i className="bi bi-plus-circle"></i></button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            malzemeFiyatSatisList && malzemeFiyatSatisList.length > 0 ?
                                                malzemeFiyatSatisList.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td align="center">
                                                                <div className="form-control form-control-sm">
                                                                    <DatePicker className="form-control form-control-sm datePickerInFormControlBox" calendarStartDay={1} todayButton="Bugün" dateFormat="dd.MM.yyyy" selected={item.tarih} onChange={(value) => { handleTarih(value, index, "satis"); }} />
                                                                </div>
                                                            </td>
                                                            <td align="center">
                                                                <select className="form-select form-select-sm" value={item.cariIdMusteri} onChange={(e) => handleCariMusteri(e.target.value, index, "satis")}>
                                                                    <option value={0}></option>
                                                                    {
                                                                        dataCariMusteri && dataCariMusteri.length > 0 ?
                                                                        dataCariMusteri.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.id}>{item.ad}</option>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td align="center">
                                                                <select className="form-select form-select-sm" value={item.paraBirimiId} onChange={(e) => handleParaBirimi(e.target.value, index, "satis")}>
                                                                    <option value={0}></option>
                                                                    {
                                                                        dataParaBirimi && dataParaBirimi.length > 0 ?
                                                                        dataParaBirimi.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.id}>{item.ad}</option>
                                                                            )
                                                                        })
                                                                        :
                                                                        null
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.fiyat} onChange={(e) => handleFiyat(e.target.value, index, "satis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdvOrani} onChange={(e) => handleKdvOrani(e.target.value, index, "satis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdv} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kdvliFiyat} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="number" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskontoOrani} onChange={(e) => handleIskontoOrani(e.target.value, index, "satis")}></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskonto} disabled></input>
                                                            </td>
                                                            <td align="center">
                                                                <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.iskontoluFiyat} disabled></input>
                                                            </td>
                                                            {
                                                                Number(malzemeAnaGrubuId) === 1 ? 
                                                                    <td align="center">
                                                                        <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.kovaFiyati} disabled></input>
                                                                    </td>
                                                                    :
                                                                    ""
                                                            }
                                                            {
                                                                Number(malzemeAnaGrubuId) === 1 ? 
                                                                    <td align="center">
                                                                        <input type="text" className="form-control form-control-sm spinButtonWithoutArrows" style={{textAlign:"right"}} value={item.paletFiyati} disabled></input>
                                                                    </td>
                                                                    :
                                                                    ""
                                                            }
                                                            <td align="center">
                                                                <button className="btn btn-sm btn-icon text-danger" onClick={() => SilMalzemeFiyat(index, "satis")}><i className="bi bi-trash3"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td align="center" colSpan={Number(malzemeAnaGrubuId) === 1 ? 13 : 11} style={{height:"48px"}}>
                                                        Kayıt yok
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Malzeme;